<template>
  <MessageBubble
    :message="message"
  >
    <template slot="text-message">

      <v-card
        class="card-content d-flex flex-row justify-center align-center"
        flat
      >
        <v-card-title class="pa-0 body-1 font-weight-medium flex-nowrap text-truncate">
          <v-icon class="mr-2">mdi-grid-large</v-icon>
          <span class="text-truncate">
            {{ json.titulo }}
          </span>
        </v-card-title>
        <v-card-actions class="ml-2 pa-1">
          <v-btn
            @click="$emit('view-details', json)"
            color="primary"
            x-small
            fab
            depressed
          >
            <v-icon>mdi-export</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

    </template>
  </MessageBubble>
</template>

<style scoped>
  .card-content {
    background-color: transparent;
  }
</style>

<script>
  import MessageBubble from '@/components/ai_workforce/chat/MessageBubble.vue';

  export default {
    name: "ChatMessageBubble",

    components: {
      MessageBubble,
    },

    props: {
      message: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      json() {
        let jsonStr = this.message.text;

        jsonStr = jsonStr.replace(/[^]*```json\n/g, "").replace(/\n```([\s\S]*)/g, "")

        return JSON.parse(jsonStr) || {}
      }
    },
  }
</script>
